var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { SteemTxUtils } from '@popup/steem/utils/steem-tx.utils';
import { LocalStorageKeyEnum } from '@reference-data/local-storage-key.enum';
import _ from 'lodash';
import LocalStorageUtils from 'src/utils/localStorage.utils';
import Logger from 'src/utils/logger.utils';
const getVestingRoutes = (name, type) => __awaiter(void 0, void 0, void 0, function* () {
    let vestingRoutes = yield SteemTxUtils.getData('condenser_api.get_withdraw_routes', [name, type]);
    return vestingRoutes.map((vestingRoute) => {
        return {
            fromAccount: vestingRoute.from_account,
            toAccount: vestingRoute.to_account,
            percent: vestingRoute.percent,
            autoVest: vestingRoute.auto_vest,
        };
    });
});
const getAllAccountsVestingRoutes = (names, type) => __awaiter(void 0, void 0, void 0, function* () {
    const allAccountsVestingRoutes = [];
    for (let i = 0; i < names.length; i++) {
        const name = names[i];
        const vestingRoutes = yield VestingRoutesUtils.getVestingRoutes(name, type);
        allAccountsVestingRoutes.push({
            account: name,
            routes: vestingRoutes,
        });
    }
    return allAccountsVestingRoutes;
});
const getLastVestingRoutes = () => __awaiter(void 0, void 0, void 0, function* () {
    const result = yield LocalStorageUtils.getValueFromLocalStorage(LocalStorageKeyEnum.LAST_VESTING_ROUTES);
    return result !== null && result !== void 0 ? result : null;
});
const getWrongVestingRoutes = (localAccounts) => __awaiter(void 0, void 0, void 0, function* () {
    let currentVestingRoutes = yield VestingRoutesUtils.getAllAccountsVestingRoutes(localAccounts.map((acc) => acc.name), 'outgoing');
    const lastVestingRoutes = yield VestingRoutesUtils.getLastVestingRoutes();
    if (!lastVestingRoutes) {
        VestingRoutesUtils.saveLastVestingRoutes(currentVestingRoutes);
        return undefined;
    }
    let accountsVestingRoutesDifferences = [];
    let missingRoutes = [];
    for (const account of localAccounts) {
        const accountVestingRoutesDifferences = {
            account: account.name,
            differences: [],
        };
        const oldRoutes = lastVestingRoutes.find((vestingRoute) => vestingRoute.account === account.name);
        const currentRoutes = currentVestingRoutes.find((vestingRoute) => vestingRoute.account === account.name);
        if (!oldRoutes && currentRoutes) {
            missingRoutes.push(currentRoutes);
            continue;
        }
        // Compare
        if (!_.isEqual(oldRoutes, currentRoutes)) {
            if (oldRoutes)
                for (const oldRoute of oldRoutes.routes) {
                    let difference = {};
                    const foundInCurrentRoutes = currentRoutes === null || currentRoutes === void 0 ? void 0 : currentRoutes.routes.find((route) => route.toAccount === oldRoute.toAccount);
                    if (foundInCurrentRoutes) {
                        if (!_.isEqual(foundInCurrentRoutes, oldRoute)) {
                            difference = { oldRoute, newRoute: foundInCurrentRoutes };
                        }
                    }
                    else {
                        difference = { oldRoute, newRoute: undefined };
                    }
                    accountVestingRoutesDifferences.differences.push(difference);
                }
            if (currentRoutes)
                for (const currentRoute of currentRoutes.routes) {
                    let difference = {};
                    const foundInOldRoutes = oldRoutes === null || oldRoutes === void 0 ? void 0 : oldRoutes.routes.find((route) => route.toAccount === currentRoute.toAccount);
                    if (foundInOldRoutes) {
                        if (!_.isEqual(foundInOldRoutes, currentRoute)) {
                            if (!accountVestingRoutesDifferences.differences.find((diff) => {
                                var _a, _b;
                                return ((_a = diff.newRoute) === null || _a === void 0 ? void 0 : _a.toAccount) === currentRoute.toAccount &&
                                    ((_b = diff.oldRoute) === null || _b === void 0 ? void 0 : _b.toAccount) === (foundInOldRoutes === null || foundInOldRoutes === void 0 ? void 0 : foundInOldRoutes.toAccount);
                            }))
                                difference = {
                                    newRoute: currentRoute,
                                    oldRoute: foundInOldRoutes,
                                };
                        }
                    }
                    else {
                        difference = { oldRoute: undefined, newRoute: currentRoute };
                    }
                    if (difference.oldRoute || difference.newRoute) {
                        accountVestingRoutesDifferences.differences.push(difference);
                    }
                }
        }
        if (accountVestingRoutesDifferences.differences.length > 0) {
            //push but remove posible empty objects
            accountsVestingRoutesDifferences.push({
                account: accountVestingRoutesDifferences.account,
                differences: accountVestingRoutesDifferences.differences.filter((i) => Object.keys(i).length),
            });
        }
    }
    saveLastVestingRoutes([...lastVestingRoutes, ...missingRoutes]);
    return accountsVestingRoutesDifferences.length > 0
        ? accountsVestingRoutesDifferences
        : undefined;
});
const saveLastVestingRoutes = (vestingRoutes) => __awaiter(void 0, void 0, void 0, function* () {
    LocalStorageUtils.saveValueInLocalStorage(LocalStorageKeyEnum.LAST_VESTING_ROUTES, vestingRoutes);
});
const sendVestingRoute = (fromAccount, toAccount, percent, autoVest, activeKey, options) => __awaiter(void 0, void 0, void 0, function* () {
    return SteemTxUtils.sendOperation([
        VestingRoutesUtils.getVestingRouteOperation(fromAccount, toAccount, percent, autoVest),
    ], activeKey, false, options);
});
const getVestingRouteOperation = (fromAccount, toAccount, percent, autoVest) => {
    return [
        'set_withdraw_vesting_route',
        {
            from_account: fromAccount,
            to_account: toAccount,
            percent: percent,
            auto_vest: autoVest,
        },
    ];
};
const skipAccountRoutes = (differences, account) => __awaiter(void 0, void 0, void 0, function* () {
    let lastRoutes = yield VestingRoutesUtils.getLastVestingRoutes();
    let lastUserRoutes = lastRoutes.find((i) => i.account === account);
    differences.map((difference) => {
        if (difference.oldRoute && difference.newRoute) {
            const foundIndexInLast = lastUserRoutes === null || lastUserRoutes === void 0 ? void 0 : lastUserRoutes.routes.findIndex((l) => { var _a; return l.toAccount === ((_a = difference.newRoute) === null || _a === void 0 ? void 0 : _a.toAccount); });
            if (foundIndexInLast !== undefined && foundIndexInLast > -1) {
                lastUserRoutes.routes[foundIndexInLast] = difference.newRoute;
            }
        }
        else if (difference.newRoute) {
            lastUserRoutes === null || lastUserRoutes === void 0 ? void 0 : lastUserRoutes.routes.push(difference.newRoute);
        }
        else if (difference.oldRoute) {
            lastUserRoutes.routes = lastUserRoutes.routes.filter((l) => { var _a; return l.toAccount !== ((_a = difference.oldRoute) === null || _a === void 0 ? void 0 : _a.toAccount); });
        }
    });
    yield VestingRoutesUtils.saveLastVestingRoutes(lastRoutes);
});
const revertAccountRoutes = (accounts, differences, account, options) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const broadcastOperations = [];
    const activeKey = (_a = accounts.find((a) => a.name === account)) === null || _a === void 0 ? void 0 : _a.keys.active;
    if (activeKey) {
        differences.map(({ oldRoute, newRoute }) => {
            if (oldRoute) {
                const { fromAccount, toAccount, percent, autoVest } = oldRoute;
                broadcastOperations.push(getVestingRouteOperation(fromAccount, toAccount, percent, autoVest));
            }
            else if (newRoute) {
                const { fromAccount, toAccount, autoVest } = newRoute;
                broadcastOperations.push(getVestingRouteOperation(fromAccount, toAccount, 0, autoVest));
            }
        });
        try {
            const options = {};
            const result = yield SteemTxUtils.sendOperation(broadcastOperations, activeKey, false, options);
        }
        catch (error) {
            Logger.error('Error while reverting vesting route(s)', true);
        }
    }
});
export const VestingRoutesUtils = {
    getVestingRoutes,
    getAllAccountsVestingRoutes,
    getLastVestingRoutes,
    saveLastVestingRoutes,
    getWrongVestingRoutes,
    getVestingRouteOperation,
    sendVestingRoute,
    skipAccountRoutes,
    revertAccountRoutes,
};
